import type {TimelineItem} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {TimelineItemType} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'

const actionText: Partial<Record<TimelineItemType, string>> = {
  [TimelineItemType.ISSUE_COMMENT]: 'commented',
  [TimelineItemType.CROSS_REFERENCE]: 'mentioned this',
  [TimelineItemType.PULL_REQUEST_REVIEW_THREAD]: 'started a review thread',
  [TimelineItemType.PULL_REQUEST_REVISION_MARKER]: 'New changes since last review',
}

export function OtherItemText({item}: {item: TimelineItem}) {
  const text = actionText[item.type] ?? 'performed an action'
  return <>{text}</>
}
